module.exports = __webpack_public_path__ + "img/shelley.f555181f.jpg";